var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardView24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "default__Category=Default, Type=Cards view, State=Enabled, Size=24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "default__stack"
  }, /*#__PURE__*/React.createElement("path", {
    id: "default__Rectangle 549",
    fill: "inherit",
    d: "M12.569 4.519a1.38 1.38 0 0 1 1.381-1.382h6.219a1.38 1.38 0 0 1 1.381 1.382v6.218a1.38 1.38 0 0 1-1.381 1.381H13.95a1.382 1.382 0 0 1-1.381-1.381V4.519Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "default__Vector",
    fill: "inherit",
    d: "M2.55 4.519c0-.764.62-1.382 1.382-1.382h6.218c.764 0 1.382.618 1.382 1.382v6.218a1.38 1.38 0 0 1-1.382 1.381H3.932a1.382 1.382 0 0 1-1.382-1.381V4.519Zm0 10.018c0-.763.62-1.382 1.382-1.382h6.218c.764 0 1.382.619 1.382 1.382v6.218c0 .763-.618 1.382-1.382 1.382H3.932a1.382 1.382 0 0 1-1.382-1.382v-6.218Zm10.019 0c0-.763.618-1.382 1.381-1.382h6.219c.763 0 1.381.619 1.381 1.382v6.218c0 .763-.618 1.382-1.381 1.382H13.95a1.382 1.382 0 0 1-1.381-1.382v-6.218Z",
    opacity: 0.48
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardView24);
export default __webpack_public_path__ + "static/media/card_view_24.3eabe893dce5802ef21546479e88d690.svg";
export { ForwardRef as ReactComponent };